export default "__VITE_ASSET__Z7dp3FJE__"